type StockFields = Record<string, unknown>;

export type StockBarShares = {
  free: number;
  reserved: number;
  inTransit: number;
};

const SET_SUFFIXES = ['Pcs', 'M2', 'M3'] as const;

const asNumber = (value: unknown): number | null => {
  if (value === null || value === undefined || value === '') return null;
  const parsed = Number(value);
  return Number.isFinite(parsed) ? parsed : null;
};

// Reserved stock is part of the physical (available) stock; in-transit is not
// in the warehouse yet. All three must come from one unit of the quantity set,
// otherwise the shares would compare different units.
export const getStockBarShares = (record: StockFields): StockBarShares | null => {
  const read = (suffix: string) => ({
    available: asNumber(record[`quantityAvailable${suffix}`]),
    reserved: asNumber(record[`quantityReserved${suffix}`]),
    inTransit: asNumber(record[`quantityInTransit${suffix}`]),
  });

  const candidates = [...SET_SUFFIXES.map(read), {
    available: asNumber(record.quantityAvailable),
    reserved: asNumber(record.quantityReserved),
    inTransit: asNumber(record.quantityInTransit),
  }];
  const picked = candidates.find((candidate) => (
    candidate.available !== null && candidate.reserved !== null && candidate.inTransit !== null
  ));
  if (!picked || picked.available === null || picked.reserved === null || picked.inTransit === null) {
    return null;
  }

  const physical = Math.max(picked.available, 0);
  const reserved = Math.min(Math.max(picked.reserved, 0), physical);
  return {
    free: physical - reserved,
    reserved,
    inTransit: Math.max(picked.inTransit, 0),
  };
};
